import { previewKeyAtom } from 'js/file_viewer/core/atoms/atom';
export const audioVideoCurrentTimestampAtom = previewKeyAtom(0);
export const audioVideoIsPlayingAtom = previewKeyAtom(false);
export const audioVideoIsDefaultAudioTrackSelectedAtom = previewKeyAtom(true);
export const audioVideoAreControlsHiddenAtom = previewKeyAtom(false);
//# sourceMappingURL=audio_video.preenvesnextjs.map
